import { AnimatedNumber, type AnimatedNumberProps } from "./animated-number";

export function AnimatedCurrency(props: Omit<AnimatedNumberProps, "format">) {
	return (
		<AnimatedNumber
			format={{
				maximumFractionDigits: 2,
				minimumFractionDigits: 2,
				style: "currency",
				currency: "EUR",
				localeMatcher: "best fit",
				currencyDisplay: "symbol",
			}}
			{...props}
		/>
	);
}
